import { Skeleton, Stack } from "@mantine/core";

export function SkeletonChart({ height = 400 }: { height?: number }) {
  return (
    <Stack gap="xs" role="status" aria-busy="true" aria-label="Loading chart">
      <Skeleton h={height} w="100%" radius="sm" />
      <Skeleton h={12} w="60%" mx="auto" />
    </Stack>
  );
}
